function identity(t){return t}module.exports=identity;